<template>
    <div id="loading-layer">
        <e-header :stitle="stitle"></e-header>
        <div class="loading-content">
            <div class="loading-main-layer">
                <div class="loading-imgs">
                    <img src="../assets/images/login/loading1.png" class="loading-text-img" alt="">
                </div>
                <div class="loading-main-box">
                    <span><font style="font-size: 30px">正在跳转中...</font></span>
                </div>
            </div>
        </div>
        <e-footer></e-footer>
    </div>
</template>
<script>
    import eHeader from '@/components/eHeader'
    import eFooter from '@/components/eFooter'
    import {autoLoginByTokenApi} from '@/api/login'
    import {setToken} from '@/utils/auth'

    export default {
        components: {
            eHeader,
            eFooter
        },
        data() {
            return {
                loading: false
            }
        },
        created() {
            setTimeout(this.autoLoginByTokenHandle(), 1000);
        },
        methods: {
            autoLoginByTokenHandle() {
                let autoTokenSid = this.$route.query.autoTokenSid
                console.log(this.$route)
                if (autoTokenSid) {
                    autoLoginByTokenApi({
                        autoTokenSid
                    }).then(res => {
                        console.log(res)
                        if (res.code != '200') {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: 'warning'
                            });
                        } else {
                            let companyInfos = []
                            companyInfos.push(res.companyInfo)
                            setToken(res.token, 1)
                            this.$store.commit('SET_CURRENT_SPACE', res.companyInfo)
                            this.$store.commit('SET_COMPSNYL_LIST', companyInfos)
                            this.$store.commit('SET_USER_INFO', res.userInfo)
                            let toPageType = res.autoLoginInfo.toPageType;
                            let contractId = res.autoLoginInfo.contractId;
                            if (contractId == null || contractId == undefined) {
                                toPageType = "1";
                            }
                            if (toPageType == null || toPageType == "" || toPageType == "1") {
                                this.$router.push({
                                    path: '/'
                                })
                            } else if (toPageType == "2") {
                                this.$router.push({
                                    path: '/flow',
                                    query: {
                                        contractId: contractId
                                    }
                                })
                            } else if (toPageType == "3") {
                                this.$router.push({
                                    path: '/sign',
                                    query: {
                                        companyId: res.autoLoginInfo.companyUserId,
                                        contractId: contractId,
                                        signType: res.autoLoginInfo.signType,
                                        hrefFrom: res.autoLoginInfo.from,
                                    }
                                })
                            }
                            this.$store.commit('SET_USER_CONTRSCT_INFO', {})
                        }
                    })
                }
            }
        }
    }
</script>
<style scoped>

    .loading-main-layer {
        width: 1500px;
        height: calc(100vh - 71px);
        margin: 0 auto;
        position: relative;
    }

    @media screen and (min-width: 1200px) and (max-width: 1499px) {
        .loading-main-layer {
            width: 1200px;
        }
    }

    .loading-content {
        width: 100%;
        height: calc(100vh - 71px);
        background: url('../assets/images/login/login-bg.png') no-repeat;
        background-size: 100% 100%;
        overflow: hidden;
        position: relative;
    }

    .loading-imgs {
        width: 100%;
        height: 150px;
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -225px;
    }

    .loading-text-img {
        display: block;
        margin: auto;
        top: 26.85%;
        left: 43.96%;
        position: absolute;
    }

    .loading-main-box {
        height: 80px;
        position: absolute;
        margin: auto;
        left: 47%;
        /* top: 198px; */
        top: 50%;
    }
</style>
